import { render, staticRenderFns } from "./NewsRibbon.vue?vue&type=template&id=cd064890&scoped=true&"
import script from "./NewsRibbon.vue?vue&type=script&lang=js&"
export * from "./NewsRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd064890",
  null
  
)

export default component.exports